import React, {Fragment} from 'react'
import styles from './Panel.scss'
import {CTA} from 'common/styleguide/CTA'
import {CircleSpinner} from 'common/spinners'
import {Set} from 'immutable'
import _ from 'lodash'

export class Panel extends React.PureComponent {
  constructor (props) {
    super(props)

    this.state = {
      initialSelectedIds: props.selectedIds,
      filter: '',
      showAll: false,
      inCreateMode: false
    }
  }

  onFilterChange = (e) => {
    this.setState({filter: e.target.value})
  }

  onOptionClicked = (e) => {
    if (e.target.type !== 'checkbox') {
      // otherwise we get two events- one for label one for input
      e.preventDefault()
    }

    if (e.target.dataset.optionId) {
      this.props.onSelectedIdsChange(parseInt(e.target.dataset.optionId, 10))
    }
  }

  onNewClicked = () => {
    this.setState({inCreateMode: true})
  }

  onCancelClicked = () => {
    this.setState({inCreateMode: false})
  }

  render () {
    const {
      options,
      selectedIds,
      valueAttr,
      newRecordString,
      createNewPending,
      dispatchCreate,
      showSpinner,
      collapsePanel
    } = this.props
    const {filter, initialSelectedIds, showAll, inCreateMode} = this.state

    if (showSpinner) {
      return <CircleSpinner size={20} />
    }

    const topIds = initialSelectedIds.size > 0 && filter === ''
      ? initialSelectedIds.intersect(selectedIds)
      : Set()
    let [topOpts, rest] = _.partition(options.toJS(), o => topIds.has(o.id))
    if (filter !== '') {
      rest = rest.filter(o => o[valueAttr].match(filter))
    }
    topOpts = topOpts.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt))
    rest = rest.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt))

    const toShow = showAll ? topOpts.concat(rest) : topOpts.concat(rest).slice(0, 4)
    const totalLength = topOpts.length + rest.length
    const showMore = !showAll && totalLength > 4

    return (
      <div className={styles.panel}>
        {inCreateMode
          ? <CreateView
            newRecordString={newRecordString}
            onCancel={this.onCancelClicked}
            createNewPending={createNewPending}
            onSave={dispatchCreate} />
          : <Fragment>
            <div className={styles.panelUpper}>
              <input
                value={filter}
                onChange={this.onFilterChange}
                placeholder='Search here...'
                className={styles.panelSearch} />
              <div className={styles.panelInner}>
                {toShow.map(o => <MultiSelectRow
                  key={o.id}
                  id={o.id}
                  selected={selectedIds.has(o.id)}
                  optionClicked={this.onOptionClicked}
                  value={o[valueAttr]} />)}
                {showMore && <a
                  onClick={(e) => { this.setState({showAll: true}) }}
                  className={styles.showMoreAnchor}>
                  Show {totalLength - 4} More Results
                </a>}
              </div>
            </div>
            <div className={styles.panelBottom}>
              <CTA style={{margin: '0px 20px 0px 0px'}} className={styles.panelCTA} onClick={collapsePanel}>Save</CTA>
              <CTA link margins={false} className={styles.panelCTA} onClick={this.onNewClicked}>New {newRecordString}</CTA>
              {selectedIds.size > 0 && <span className={styles.selectedText}>{selectedIds.size} Selected</span>}
            </div>
          </Fragment>}
      </div>
    )
  }
}

class MultiSelectRow extends React.PureComponent {
  render () {
    const {id, value, selected, optionClicked} = this.props

    return (
      <div className={styles.row} onClick={optionClicked}>
        <input id={`checkboxFor${id}`} data-option-id={id} type='checkbox' checked={selected} readOnly />
        <label htmlFor={`checkboxFor${id}`} data-option-id={id}>{value}</label>
      </div>
    )
  }
}

class CreateView extends React.PureComponent {
  state = {
    name: ''
  }

  componentDidUpdate (prevProps) {
    const {createNewPending, onCancel} = this.props

    if (prevProps.createNewPending && !createNewPending) onCancel()
  }

  onNameChange = (e) => {
    this.setState({name: e.target.value})
  }

  onSaveClicked = (e) => {
    e.preventDefault()
    const {onSave} = this.props
    const {name} = this.state

    onSave(name)
  }

  render () {
    const {newRecordString, onCancel, createNewPending} = this.props
    const {name} = this.state

    return <Fragment>
      <div className={styles.newTop}>
        <input
          value={name}
          onChange={this.onNameChange}
          disabled={createNewPending}
          placeholder={`Untitled ${newRecordString}`} />
        <CTA margins={false} onClick={this.onSaveClicked}>Save</CTA>
      </div>
      <div className={styles.newInner}>Create a new {newRecordString} for your route</div>
      <div className={styles.newBottom}><CTA link margins={false} onClick={onCancel}>Cancel</CTA></div>
    </Fragment>
  }
}
